import { Table } from "antd";

import { RefundTableProps } from "./types";
import { useRefundColumns } from "./hooks";

const RefundTable: React.FC<RefundTableProps> = ({
  additionalColumns,
  ...props
}) => {
  const columns = useRefundColumns({ additionalColumns });

  return <Table rowKey="id" {...{ columns }} {...props} />;
};

export default RefundTable;
